import { Literal, Partial, Record, Union } from "runtypes";
import { Name } from "./person";
export const MiddlewareRoles = Union(Literal("none"), Literal("student"), Literal("staff"));
export const MiddlewareResponse = Record({
  role: MiddlewareRoles
}).And(
  Partial({
    courseName: Name
  })
);
//# sourceMappingURL=middleware.js.map
